<template>
  <div class="page-title-2" :class="{full}">
    <div class="left">
      <div class="title">{{ title }}</div>
      <div class="subtitle" v-if="subtitle">{{ subtitle }}</div>
    </div>
    <div class="right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "pageTitle",

    props: {
      title: String,
      subtitle: String,
      full: Boolean
    },

    watch: {
      title: {
        immediate: true,
        handler() {
          this.$store.state.pageTitle = this.title;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .page-title-2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    width: 100%;
    max-width: 1100px;
    margin-left: auto;
    margin-right: auto;
    flex-shrink: 0;

    &.full {
      max-width: none;
    }

    .title {
      font-weight: bold;
      font-size: 20px;
      color: #404040;
    }

    .subtitle {
      color: #808080;
      font-size: 14px;
      margin-top: 5px;
    }
  }
</style>